import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLibreofficeComponent } from './simple-icons-libreoffice.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLibreofficeComponent ],
    exports:      [ SimpleIconsLibreofficeComponent ],
    bootstrap:    []
})
export class SimpleIconsLibreofficeModule {}
